
export class Marker {
    public label: string = '';
    public lat: number = 0.0;
    public lng: number = 0.0;
    public count: number = 0;
}